// extracted by mini-css-extract-plugin
var _1 = "IntegrationsConflictQueue-modulecontent__tQ7Cd WidgetContentContainer-moduleWidgetContentContainer__HxIkI";
var _2 = "IntegrationsConflictQueue-moduleskeleton__YdA_1";
export { _1 as "content", _2 as "skeleton" }
